import { appName, appPublicUrl, brandLogo, brandLogoMin } from 'consts'
import { NavLink } from 'react-router-dom'

const getBrandContent = () => {
  return (
    <div className='logo'>
      <NavLink to='/'>
        <img src={appPublicUrl + brandLogo} alt='Application Logo' className="header-logo" />
        <img src={appPublicUrl + brandLogoMin} alt='Application Logo' className="header-logo-min" />
      </NavLink>
      <p>{appName.toUpperCase()}</p>
    </div>
  )
}

export default getBrandContent
